import * as React from 'react';
import {Tag} from './Tag';
import style from './tag.scss';

type UlElementProps = JSX.IntrinsicElements['ul'];

export interface TagsProps extends UlElementProps {
  tags: any;
  wrapperComponent?: string | React.ComponentClass;
}

export function Tags({
  tags = [],
  wrapperComponent = 'ul',
  children,
  className,
  ...restProps
}: TagsProps) {
  const Wrapper = wrapperComponent;

  return (
    <Wrapper
      className={className}
      {...restProps}
    >
      {children}
      {tags.map((tag) => (
        <li key={tag.tag} className={style.listItem}>
          <Tag {...tag} />
        </li>
      ))}
    </Wrapper>
  );
}

export default Tags;
